var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{ref:"explanation",staticClass:"explanation"},[_c('b',[_vm._v(_vm._s(_vm.$i18n('explanation'))+":")]),_vm._v("\n    "+_vm._s(_vm.text)+"\n\n  ")]),_vm._v(" "),_c('a',{attrs:{"href":"#expand"},on:{"click":_vm.expand}},[_vm._v("\n    "+_vm._s(_vm.$i18n('globals.show_more'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }